export default "__VITE_ASSET__BIwZcIbQ__"